import { render, staticRenderFns } from "./issue.vue?vue&type=template&id=9d56cc72&scoped=true&lang=pug"
import script from "./issue.vue?vue&type=script&lang=js"
export * from "./issue.vue?vue&type=script&lang=js"
import style0 from "@/CommonDP/mongeView/common/common.scss?vue&type=style&index=0&id=9d56cc72&prod&lang=scss&scoped=true&external"
import style1 from "./issue.vue?vue&type=style&index=1&id=9d56cc72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d56cc72",
  null
  
)

export default component.exports